<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="false">
    <mat-toolbar>Menu</mat-toolbar>
    <mat-nav-list>
      <a mat-list-item routerLink="/" (click)="drawer.close()">Home</a>
      <a mat-list-item routerLink="/operations" (click)="drawer.close()">Operations</a>
      <a mat-list-item routerLink="/user/login" (click)="drawer.close()">Login</a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar>
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">

        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <is-breadcrumbs></is-breadcrumbs>

      <span class="fill-space"></span>

      <div *ngIf="(isHandset$ | async) !== true">
        <a mat-button routerLink="/user/login" *ngIf="(loggedIn$ | async) !== true">🔑 Login</a>
      </div>

      <button
        *ngIf="(loggedIn$ | async)"
        mat-flat-button
        (click)="onSignOut()"
      >Log out</button>
    </mat-toolbar>

    <ng-content></ng-content>

  </mat-sidenav-content>
</mat-sidenav-container>
